import dayjs from "dayjs";
import type { FC, RefObject } from "react";
import { EmailCard } from "../../../../../components/EmailCard/EmailCard";
import type { EmailSearchInput } from "../../../../../hooks/useEmailsRestApi";
import type { EmailWithStatus } from "../..";

export type HREmailsCardsUIProps = {
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  onToggleFavoriteEmail: (emailId: string, favorite: boolean) => void;
  currentSearchInput: EmailSearchInput;
  scrollCardRef: RefObject<HTMLDivElement>;
  scrollCardId: string | null;
};

export const HREmailsCardsUI: FC<HREmailsCardsUIProps> = ({
  emails,
  onSelectEmail,
  onToggleFavoriteEmail,
  scrollCardRef,
  scrollCardId,
}) => {
  if (emails.length === 0) {
    return (
      <div className="flex justify-center">
        <div className="text-left text-gray-500 max-w-xl">
          <p>条件に合う検索結果はありません。</p>
          <div className="h-4" />
          <p>あるいは、あなたのアカウントがどの会社にも紐づいていません。</p>
          <p>管理者にアカウントと所属会社の紐づけ作業を依頼してください。</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {emails.map(email => (
        <EmailCard
          key={email.id}
          emailId={email.id}
          onSelectEmail={onSelectEmail}
          onToggleFavoriteEmail={onToggleFavoriteEmail}
          favorite={email.favorite}
          title={email.subject}
          date={dayjs(email.date).toString()}
          period={email.hrColumn?.startedDate || null}
          content={email.content}
          reward={email.hrColumn?.reward || null}
          isRemoteEnabled={email.hrColumn?.isRemoteNeeded || false}
          station={email.hrColumn?.station || null}
          technology={email.hrColumn?.technology || null}
          industryCategory={email.hrColumn?.industryCategory || null}
          remoteFrequency={email.hrColumn?.remoteFrequency || null}
          isRead={email.read}
          age={email?.hrColumn?.age || null}
          gender={email?.hrColumn?.gender || null}
          hrTypes={email?.hrColumn?.hrTypes || null}
          depth={email?.hrColumn?.depth ?? null}
          hasAttachments={email.hasAttachments}
          duplicateCount={email.duplicateCount}
          originalMessageId={email.originalMessageId}
          scrollCardRef={scrollCardRef}
          scrollCardId={scrollCardId}
        />
      ))}
    </div>
  );
};
